import * as React from "react";
const SvgCheckboxUncheckeddark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 1, y: 1, width: 22, height: 22, rx: 3.25, stroke: "white", strokeWidth: 1.5 }));
export default SvgCheckboxUncheckeddark;
